import React from 'react';
import { connect } from "react-redux";
import {
    Input,
    Button,
    Navbar,
    Nav,
    NavLink,
    Row,
    Col,
    Spinner,
    UncontrolledTooltip,
} from 'reactstrap';
import eyeIcon from '../../assets/eye-highlight.svg'
import listIcon from '../../assets/list-blue.svg'
import zoomInIcon from '../../assets/zoom-in.svg'
import zoomOutIcon from '../../assets/zoom-out.svg'
import { NavLink as RRNavLink } from 'react-router-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Tour from '../../Tour';
import ImageMapper from '../../components/ImageMapper/imageMapper'
import NavBar from '../../components/NavBar/navBar'
import {
    fetchBuilding,
    fetchFloors,
    fetchFloorPlan,
    fetchLocationData,
    saveSample,
    updateSample,
    deleteSample
} from '../../actions'
import '../../components/FloorPlanMapping/floorPlanMapping.css';
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from 'react-toastify';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../AppInsights';
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import Overlay from '../Overlay/overlay';

let building=sessionStorage.getItem("building")
let buildingId=sessionStorage.getItem("buildingId")
let floor=sessionStorage.getItem("floor")
let floorName=sessionStorage.getItem("floorName")

const initialState = {
    name: "floor-map",
    width: 0,
    height: 0,
    filter_date_time: "",
    analysis:"SNP",
    loader: false,
    zoomInEnabled: true,
    zoomOutEnabled: true
}

class FloorPlanMapping extends React.Component {
    constructor(props) {
        super(props);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.onChange = this.onChange.bind(this)
        this.onSelectBuilding = this.onSelectBuilding.bind(this)
        this.onSelectFloor = this.onSelectFloor.bind(this)

        building=sessionStorage.getItem("building")
        buildingId=sessionStorage.getItem("buildingId")
        floor=sessionStorage.getItem("floor")
        this.floorInitialState = {
            building: building?building:localStorage.getItem("guest")?"BldgA":"",
            floor: floor?floor:localStorage.getItem("guest")?20000:"",
            buildingId: buildingId?buildingId:localStorage.getItem("guest")?20000:"",
            floor_plan:"",
            show: false,
            overlayOpen: false
        }
        Object.assign(initialState, this.floorInitialState);
        if (this.props.location && this.props.location.state && this.props.floorsList.length > 0) {
            Object.assign(initialState, this.props.location.state)
        }
        this.state = initialState
        this.props.fetchFloors(this.state.buildingId)
        if (this.state.floor !== '') {
            this.fetchLocationAreas(this.state.floor, this.state.filter_date_time,this.state.analysis)
        }

        this.floorElement = element => {
            if (element) {
                let floorDim = element.container.getBoundingClientRect()
                this.setState({
                    leftFloor: floorDim.left,
                    topFloor: floorDim.top,
                });
            }
        };
        setTimeout(() => {
            if(localStorage.getItem("guest"))
            this.applyfilter()
        });
    }

    componentDidMount() {
        if (sessionStorage.getItem("building"))
            this.onSelectBuilding("", true)
        this.props.fetchBuilding().then( () =>{
            if (sessionStorage.getItem("building"))
            this.onSelectBuilding("", true)
        })
    }

    componentWillMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }
    updateWindowDimensions() {
        let width = window.innerWidth * 0.66
        this.setState({ width: 865, height: 550, zoomOutEnabled: false, zoomInEnabled: width<2000?true:false});
    }
    
    onSelectBuilding = (event,flag=false) => {
        if(flag===false)
        {
        const {value,selectedOptions}=event.target
        sessionStorage.setItem("building",value)
        sessionStorage.setItem("buildingId",selectedOptions[0].id)
        sessionStorage.setItem("buildingName",selectedOptions[0].innerText)
        sessionStorage.setItem("floor","")
        sessionStorage.setItem("floorId","")
        sessionStorage.setItem("floorName","")
        }        this.setState(prevState => ({
            ...this.state,
            building:sessionStorage.getItem("building"),
            buildingId: sessionStorage.getItem("buildingId"),
            buildingName:sessionStorage.getItem("buildingName"),
            floor: "",
            floorId:flag? prevState.floorId: "",
            floorName:flag? prevState.floorName: "",
            areas: flag? prevState.areas: [],
            floor_plan: flag? prevState.floor_plan: "",
            show: flag? prevState.show: false
        }), async() => {
           await this.props.fetchFloors(this.state.buildingId)
            if(sessionStorage.getItem("floor"))
           await this.onSelectFloor("",true)
        })
    }

    onSelectFloor = (event,flag=false) => {
        if(flag===false)
        {
        const {value,selectedOptions}=event.target
        sessionStorage.setItem("floorName",selectedOptions[0].innerText)
        sessionStorage.setItem("floorId",selectedOptions[0].id)
        sessionStorage.setItem("floor",value)
        }
        this.setState(prevState => ({
            ...this.state,
            floor: sessionStorage.getItem("floor"),
            floorId:sessionStorage.getItem("floorId"),
            floorName:sessionStorage.getItem("floorName"),
            floor_plan: flag? prevState.floor_plan: "",
            show: flag? prevState.show: false
        }))
    }

    onChange = date => {
        return this.setState({ date_time: date })
    };

    handleChange(event) {
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        })
    };



    resetFloorData = () => {
        this.setState(this.floorInitialState)
        this.resetSampleData()
    }


    clicked = (area) => {
        if (area.type === "sample_floor_room") {
            this.setState({overlayOpen: true, locationID: area.locationObject.location_id})
        }
    }

    enterArea(area) {
        if (area.type === "sample") {
            this.setState({
                hoveredArea: area,
                hoveredType: "sample",
                hoveredName: area.sampleObject.sample_id,
                hoveredTypeOfSample: area.sampleObject.type_of_samples,
                hoveredTypeofAnalysis: area.sampleObject.type_of_analysis,
                hoveredLocationId: area.sampleObject.location + (area.sampleObject.unit ? `_${area.sampleObject.unit.unit_id}` : ''),
                hoveredDateAndTime: moment(new Date(area.sampleObject.date_time)).format('MMMM D, YYYY HH:mm')
            });
        }
        else if (area.type === "location") {
            this.setState({
                hoveredArea: area,
                hoveredType: "location",
                hoveredName: area.locationObject.room.room_name,

            });
        }
        else if (area.type === "sample_floor_room") {
            this.setState({
                hoveredArea: area,
                hoveredType: "location",
                hoveredName: area.locationObject.room.room_name,

            });

        }
    }


    leaveArea(area) {
        this.setState({
            hoveredArea: null,
            hoveredType: null,
            hoveredName: null,
            hoveredTypeOfSample: null,
            hoveredTypeofAnalysis: null,
            hoveredLocationId: null,
            hoveredDateAndTime: null
        });
    }

    getTipPosition(area) {
        if (area && area.locationObject) {
            let typeOfArea = 'Floor'
            let style = { top: `${this.state['top' + typeOfArea] + area.center[1]}px`, left: `${this.state['left' + typeOfArea] + area.center[0] - this.state.width * 0.075}px` }

            return style;
        }
    }

    handleButtonClick = (e, row) => {
        this.setState(prevState => ({
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            deleteSampleID: this.state.sample_id,
            deleteID: this.state.id
        }));
    }


    getSampleMapping = (samples_list, coords, locationObject, areas,analysis) => {
        if (coords.length > 4){
        coords = locationObject.rect_coordinates.split(",").map(Number)
         }
        let [x1, x2] = coords[0] < coords[2] ? [coords[0], coords[2]] : [coords[2], coords[0]]
        let y1 = coords[1] < coords[3] ? coords[1]: coords[3]
        let width = x2 - x1

        let len = 10 //length of the square
        let mar = 10 //margin between the squares

        let samples_width = ~~(width / (len + mar)) - 1

        samples_list.forEach((sampleObject, i) => {
            let horiz_count = ~~(i % samples_width) // nth sample position horizontally in location
            let vert_count = ~~(i / samples_width) //  nth sample position vertically in location
            let coords = [x1 + mar * (horiz_count + 1) + len * horiz_count, y1 + mar * (vert_count + 1) + len * vert_count, x1 + mar * (horiz_count + 1) + len * (horiz_count + 1), y1 + mar * (vert_count + 1) + len * (vert_count + 1)]
            let preFillColor,strokeColor
            preFillColor = (analysis ==="Other") ? "#9400d3":"#faaf75"
            strokeColor = (analysis ==="Other") ? "#9400d3":"#faaf75"
            areas.push({ name: sampleObject.sample_id, shape: "rect", coords: coords, preFillColor: preFillColor, strokeColor: strokeColor, type: 'sample', rx: '12px' })
        })
        return areas
    }

    getLocationMapping = (locationData,analysis) => {
        let areas = []
        let [floor_map, floor_name, floor_plan_width, building_name] = ''

        let floor_data = locationData.floor_data

        floor_map = floor_data.floor_plan
        floor_name = floor_data.floor_name
        floor_plan_width = floor_data.floor_plan_width
        building_name = floor_data.building.building_name

        let locationMapData = locationData.data

        locationMapData.forEach((locationObject, i) => {

            let coords = locationObject.coordinates.split(",").map(Number)
            let samples_list = locationObject.samples
            let sample_areas = []
            let shape = ""
            if(coords.length >4){
                shape = "poly"
            }
            else {
                shape = "room" 
            }
            if (samples_list.length > 0) {
                sample_areas = this.getSampleMapping(samples_list, coords, locationObject, sample_areas,analysis)
            }
            areas.push({ name: locationObject.room.room_name, sample_areas: sample_areas, shape: shape, coords: coords, locationObject: locationObject, type: 'sample_floor_room', strokeColor: '#9398c7', preFillColor: "#f1f2f869", fillColor: "#ebfcfc", text: locationObject.room.room_name })
            areas.push(...sample_areas)
        });

        return [areas, floor_map, floor_name, floor_plan_width, building_name]
    }

    fetchLocationAreas = (floorId, date,analysis) => {
        this.setState({loader: true})
        this.props.fetchLocationData({ 'floor__id': floorId, 'date_time': date ,'analysis' : analysis}).then(response => {
            if (response.status === 200) {
                if ("locations_data" in response.data && "stats" in response.data) {
                    appInsights.trackTrace({message: 'Flooplan and Location Data is fetched successfully', properties:{page: "floorPlanMapping", name: response.data.locations_data.floor_data.floor_name, id: this.state.floorId}, severityLevel: SeverityLevel.Information});
                    let locations_data = response.data.locations_data
                    let stats = response.data.stats

                    let [areas, floor_plan, floor_name, floor_plan_width, building_name] = this.getLocationMapping(locations_data,analysis)
                    this.setState({
                        areas: [...areas],
                        floor_plan: floor_plan,
                        floor_name: floor_name,
                        floor_plan_width: floor_plan_width,
                        building_name: building_name,
                        totalSamples: stats.total_samples,
                        ngs: stats.ngs,
                        classical: stats.classical,
                        loader: false,
                    })
                }
            }
            else {
                this.setState({loader: false})
                let message = "Errors in loading locations data!"
                appInsights.trackTrace({message: message, properties:{page: "floorPlanMapping", name: this.state.floorName||floorName, id: this.state.floorId}, severityLevel: SeverityLevel.Error});
                toast.error(message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }
        }).catch((error) => {
            this.setState({loader: false})
            let message = "Errors in loading locations data!"
            appInsights.trackTrace({message: message, properties:{page: "floorPlanMapping", error: error, name: this.state.floorName||floorName, id: this.state.floorId}, severityLevel: SeverityLevel.Error});
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }

    onFilterDateChange = date => {
        let datetime = new Date()
        datetime.setDate(date.getDate());
        datetime.setMonth(date.getMonth());
        datetime.setFullYear(date.getFullYear());
        this.setState({ filter_date_time: datetime || "" })
    }

    applyfilter = () => {
        let date = this.state.filter_date_time === "" ? "" : moment.utc(new Date(this.state.filter_date_time)).format('YYYY-MM-DD')
        if (this.state.building === '') {
            let message = "Please select a building!"
            appInsights.trackTrace({message: message, properties:{page: "floorPlanMapping"}, severityLevel: SeverityLevel.Verbose});
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        if (this.state.floor === '') {
            let message = "Please select a floor!"
            appInsights.trackTrace({message: message, properties:{page: "floorPlanMapping"}, severityLevel: SeverityLevel.Verbose});
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else {
            this.setState({
                show: true,
            })
            this.fetchLocationAreas(this.state.floor, date,this.state.analysis)
            this.updateWindowDimensions()
        }
    }

    resetData = () => {
        this.setState({
            ...this.floorInitialState,
            areas: null,
            totalSamples: null,
            filter_date_time: ""
        })
    }

    onSelectAnalysis = (e) =>{
        this.setState({
            ...this.state,
            analysis: e.target.value,
            }) 
    }

    zoomIn = () => {
        let width = this.state.width
        if (width < 2000) {
            width = width + ((2 / 100) * width)
            this.setState({ width: width, zoomOutEnabled: true, zoomInEnabled: width<2000?true:false})
        
            //To increase each coordinate value to keep the mapping in place
            if(!localStorage.getItem('guest') && !localStorage.getItem('species')){
                this.state.areas.forEach((item, index) =>{
                    let new_coords = []
                    let new_item 
                    item['coords'].forEach((item) => {
                        new_item = item + ((2 / 100) * item)
                        new_coords.push(new_item)
                    })
                    this.state.areas[index]['coords'] = new_coords
                    let new_areas = this.state.areas
                    new_areas.coords = new_coords
                })
                this.setState({areas : this.state.areas})
            }
        }
    }
    zoomOut = () => {
        let actualwidth = window.innerWidth * 0.66
        let width = this.state.width
        if (width > actualwidth) {
            width = width - ((2 / 100) * width)
            this.setState({ width: width, zoomInEnabled: true, zoomOutEnabled: width > actualwidth})
        
            //To decrease each coordinate value to keep the mapping in place
            if(!localStorage.getItem('guest') && !localStorage.getItem('species')){
                this.state.areas.forEach((item, index) =>{
                    let new_coords = []
                    let new_item 
                    item['coords'].forEach((item) => {
                        new_item = item - ((2 / 100) * item)
                        new_coords.push(new_item)
                    })
                    this.state.areas[index]['coords'] = new_coords
                    let new_areas = this.state.areas
                    new_areas.coords = new_coords
                })
                this.setState({areas : this.state.areas})
            }
        }
    }

    toggleOverlayModal = () =>{
        this.setState(prevState => ({
            overlayOpen: !prevState.overlayOpen,
        }));
    }

    render() {
        return (
            <>
                <div className=" samples-page page-layout" data-tut="reactour__floorPlan">
                    <NavBar />
                    <div className="grid-data floormap-grid-data">     
                        <Row className="sample-list-header" form>
                            <Navbar className="navbar-results " light expand="md">
                                <Nav navbar  data-tut="reactour__nav">
                                    <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/samples/"><span className="nav-col"><img src={eyeIcon} className="nav-icons" alt=""/>Map View</span></NavLink>
                                    <NavLink tag={RRNavLink} className="sample-nav-link" activeClassName="active" to="/samples/addsamples/"><span className="nav-col"><img src={listIcon} className="nav-icons" alt=''/>List of Samples</span></NavLink>
                                </Nav>
                            </Navbar>
                        </Row>
                        <div className='sample-input-area' data-tut="reactour__options">
                        <Row form>
                            <Col sm={4} md={3} lg={2}>
                                <Input className={this.state.building? this.props.sideBarHover?"sample-input-fields no-display":"sample-input-fields":this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"}  type="select" name="building" id="buildingId" value={this.state.building} onChange={this.onSelectBuilding} size="1">
                                    <option className="dashboard-options" value="" default disabled>Region*</option>
                                    {this.props.buildingList.map((building, key) => {
                                        return <option key={building.id} className="dashboard-options" id={building.id} value={building.building_id}>{building.building_name}</option>
                                    })}
                                </Input>
                            </Col>
                            <Col sm={4} md={3} lg={2}>
                                <Input className={this.state.floor? this.props.sideBarHover?"sample-input-fields no-display":"sample-input-fields":this.props.sideBarHover? "sample-input-fields default-disabled no-display":"sample-input-fields default-disabled"} type="select" name="floor" id="floorId" value={this.state.floor} onChange={this.onSelectFloor} size="1">
                                    <option className="dashboard-options" value="" default disabled>Map*</option>
                                    {this.props.floorsList.map((floor, key) => {
                                        return <option className="dashboard-options" id={floor.id} key={key} value={floor.id}>{floor.floor_name}</option>
                                    })}
                                </Input>
                            </Col>
                            <Col sm={4} md={3} lg={2}>
                                <div>
                                <DatePicker id="floor-date-time" onChange={this.onFilterDateChange} selected={this.state.filter_date_time}
                                    filterDate={(date) => {
                                        return moment() > date;
                                    }}
                                    maxDate={new Date()}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="Date"
                                    className="sample-input-fields form-control"
                                    autoComplete='off'
                                    wrapperClassName="datepicker-wrapper"
                                    dateFormat="MMMM d, yyyy"
                                    dateFormatCalendar=" " />
                                </div>
                            </Col>
                            <Col sm={4} md={3} lg={2}>
                                <Input className={this.props.sideBarHover? "sample-input-fields no-display":"sample-input-fields"} type="select" name="analysis" id="floorId" value={this.state.analysis} onChange={this.onSelectAnalysis} size="1">
                                    <option className="dashboard-options" value="SNP" default>WGS</option>
                                    <option className="dashboard-options" value="Other">Other</option>
                                </Input>
                            </Col>
                            <Col className="clear-apply-end" data-tut="reactour__apply">
                                <Button className="sample-clear-button" id="clearButton" outline color="secondary" type="reset" onClick={this.resetData}>Clear</Button>
                                <Button id="applyFloorButton" type="submit" onClick={this.applyfilter}>Apply{this.state.loader ? <Spinner className="sample-floor-spinner"/> : null}</Button>
                            </Col>
                        </Row>
                        </div>
                        {this.state.show ?
                            <div>
                                <Row className="floorplan-header-data"> 
                                    {this.state.totalSamples || this.state.totalSamples === 0 ? <Col sm={12} md={10} lg={10} className="center-align"><div className="samples-count-text">Total In Progress Samples on the Map <span className="samples-count-value">{this.state.totalSamples}</span></div></Col> : null}
                                    {this.state.areas && this.state.floor_plan ?
                                        <Col sm={1} md={1} lg={1} className="zoom-borders">
                                            <div className={"border-icons border-icons-left"+(this.state.zoomInEnabled?"":" border-icons-disable")} id="ZoomIn" onClick={this.zoomIn}>
                                                <img id="ZoomIn" src={zoomInIcon} alt=''/>
                                                <UncontrolledTooltip placement="top" target="ZoomIn">
                                                    Zoom In
                                                </UncontrolledTooltip>
                                            </div>
                                            <div className={"border-icons border-icons-right"+(this.state.zoomOutEnabled?"":" border-icons-disable")} id="ZoomOut" onClick={this.zoomOut} >
                                                <img src={zoomOutIcon} alt=''/>
                                                <UncontrolledTooltip placement="top" target="ZoomOut">
                                                    Zoom Out
                                                    </UncontrolledTooltip>
                                            </div>
                                        </Col>
                                    :null}
                                </Row>
                                {this.state.areas && this.state.floor_plan?
                                    <Row className="center-align floorplan-overflow">
                                        <Col data-tut="reactour__floor" className="center-align" >
                                            <ImageMapper
                                                ref={this.floorElement}
                                                id='map'
                                                src={this.state.floor_plan}
                                                key={this.state.areas.length}
                                                map={{ name: this.state.name, areas: this.state.areas }}
                                                imgWidth={this.state.floor_plan_width}
                                                width={this.state.width}
                                                onClick={area => this.clicked(area)}
                                            />
                                        </Col>
                                    </Row>
                                    : null}
                            </div>
                        :
                            null
                        }
                    </div>
                </div>   
                {this.state.overlayOpen?
                    <Overlay 
                        overlayOpen={this.state.overlayOpen} 
                        toggleOverlayModal={this.toggleOverlayModal} 
                        locationId={this.state.locationID} 
                        date_time={this.state.filter_date_time}
                        applyOnFLoor={this.applyfilter}
                    />:null}
                <ToastContainer autoClose={3000} />
                {this.props.isTourOpen?<Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} />:null}
            </>

        )
    }
}

const mapStateToProps = state => {
    return {
        locationAreas: state.location_data.locationData,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
        floor: state.floor,
        building: state.building
    }
}

export default withAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchLocationData,
        fetchBuilding,
        fetchFloors,
        fetchFloorPlan,
        saveSample,
        updateSample,
        deleteSample
    }
)(FloorPlanMapping), 'Floor Plan', 'FloorPlanMapping')